<template>
    <div>
        <base-header type="gradient-success" class="pb-6">
        </base-header>
        <show-product/>
    </div>
</template>
<script>
    import ShowProduct from "../../components/Product/ShowProduct";
    //import {bus} from '../../components/Product/bus-product'
    import {product_service} from '../../services/product/ProductService'

    export default {
        components: {ShowProduct},
        created() {
            product_service.GetAllProduct()
            product_service.GetAllProductSku()
            product_service.GetAllCategory()
            product_service.GetAllProductType()
            product_service.GetAllUnitType()


        }
    }
</script>